import { frontendURL } from 'dashboard/helper/URLHelper';
import SchedulerIndex from './pages/SchedulerIndex.vue';

export const routes = [
  {
    path: frontendURL('accounts/:accountId/scheduled-messages'),
    name: 'wasapi_scheduler_index',
    component: SchedulerIndex,
    meta: { permissions: ['administrator', 'agent'] },
  },
];
